import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL, ICreateExcessContributionFormDto } from '@/dtos';

import { TAX_FORMS_LIST_QUERY_KEY } from '../TaxForms/queries/useTaxFormsList.query';

export interface ExcessContributionWithdrawPayload {
  employee_id: number;
  account_id: number;
  amount: number;
  excess_earnings: number;
  payment_method_id: number;
  file_url: string;
}

interface ExcessContributionWithdrawResponse {
  excess_contribution_id: number;
}

export const useCreateExcessContributionQuery = (
  onSuccess?: (data?: ExcessContributionWithdrawResponse) => void,
  onError?: (errorMessage?: string) => void
) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    (payload: ICreateExcessContributionFormDto) => api.post(API_URL.TAX_FORMS_EXCESS_CONTRIBUTIONS, payload),
    {
      onSuccess: (response) => {
        queryClient.invalidateQueries({
          queryKey: [TAX_FORMS_LIST_QUERY_KEY],
        });
        onSuccess?.(response?.data);
      },
      onError: (error) => {
        const errorMessage = _.get(error, 'response.data.elevate_error_message', '') as string;
        onError?.(errorMessage);
      },
    }
  );

  return {
    create: mutateAsync,
    isLoading,
    isError,
    isSuccess,
  };
};
